import { ISwoolBaseResponse } from "../types/api";
import { ILegalEntityResponseItem } from "../types/companies.types";
import api from ".";

const legalEntityApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLegalEntity: build.query<
      ILegalEntityResponseItem,
      { country_id: string; registration_number: string }
    >({
      query: (params) => {
        return {
          url: "/api/utils/legal-entity-info",
          method: "GET",
          params,
        };
      },
      transformResponse: (
        data: ISwoolBaseResponse<ILegalEntityResponseItem>,
      ) => {
        return data.data;
      },
    }),
  }),
});

export const { useLazyGetLegalEntityQuery } = legalEntityApi;
